export function normalizedPortalBaseUrlPathPrefix() {
  const portalBaseUrlPath = `${window.PORTAL_BASE_URL_PATH || ''}`.trim();
  if (!portalBaseUrlPath || portalBaseUrlPath === '/') return '';

  // Defensive normalization in case env/config injects extra slashes.
  const normalizedPath = portalBaseUrlPath.replace(/^\/+|\/+$/g, '');
  if (!normalizedPath) return '';

  return `/${normalizedPath}`;
}
